/** Nettoyage local après « Supprimer le brouillon ».

Le rapport enregistré n'est pas visé : `deleteServerReport` reste faux.
Les photos déjà enregistrées (`persisted`) restent sur l'appareil. La file
d'envoi de ce brouillon, et les photos sans rapport, partent avec lui.
Une file d'un autre rapport n'est pas touchée.
*/
export function localCleanupAfterDraftDelete(queued, reportId) {
  const dropPhotoIds = [];
  const keepPhotoIds = [];
  const current = String(reportId || '');
  for (const photo of queued || []) {
    if (!photo?.id) continue;
    if (photo.persisted) {
      keepPhotoIds.push(photo.id);
      continue;
    }
    const tagged = String(photo.reportId || '');
    if (!current || !tagged || tagged === current) dropPhotoIds.push(photo.id);
    else keepPhotoIds.push(photo.id);
  }
  return {
    clearLocalDraft: true,
    deleteServerReport: false,
    dropPhotoIds,
    keepPhotoIds,
  };
}
